/* BlackBole cash-on-delivery order form. Opens from "Cash on delivery" on a product page and from the bag. */
(function () {
  var C = window.BBCOD, root = document.getElementById('bbCod');
  if (!C || !root) return;
  var $ = function (id) { return document.getElementById(id); };
  var items = [], source = '', state = { zone: 'inside', code: '', disc: 0, quote: null }, busy = false, qt = 0;

  function fmt(c) { return C.money.replace(/\{\{\s*\w+\s*\}\}/, Math.round(c / 100).toLocaleString('en-IN')); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u.replace(/([?&])width=\d+/, '$1width=' + w) + (/[?&]width=/.test(u) ? '' : (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w); }

  // our form replaces the EasySell one on this site
  [].forEach.call(document.querySelectorAll('.es-popup-button-overwrite'), function (b) { b.classList.remove('es-popup-button-overwrite'); });
  $('codItems').parentNode.querySelectorAll('[data-zone]').forEach(function (b) { b.textContent = fmt(C.zones[b.getAttribute('data-zone')].p); });

  // ---------- open / close ----------
  var lastFocus = null;
  function open(list, src) {
    items = list; source = src; state.code = ''; state.disc = 0; state.quote = null;
    $('codForm').hidden = false; $('codDone').hidden = true; $('codMsg').textContent = ''; $('codCodeMsg').textContent = ''; $('codCode').value = '';
    try { var s = JSON.parse(localStorage.getItem('bbCodMe') || '{}'); if (s.n && !$('codName').value) $('codName').value = s.n; if (s.p && !$('codPhone').value) $('codPhone').value = s.p; if (s.a && !$('codAddr').value) $('codAddr').value = s.a; if (s.e && !$('codEmail').value) $('codEmail').value = s.e; if (s.z) setZone(s.z); } catch (e) {}
    drawItems(); totals(); quote();
    lastFocus = document.activeElement;
    root.classList.add('on'); root.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { (!$('codName').value ? $('codName') : !$('codPhone').value ? $('codPhone') : $('codGo')).focus({ preventScroll: true }); }, 60);
    track('InitiateCheckout');
  }
  function close() {
    root.classList.remove('on'); root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  [].forEach.call(root.querySelectorAll('[data-cod-close]'), function (x) { x.addEventListener('click', close); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });

  // ---------- items and totals ----------
  function drawItems() {
    $('codItems').innerHTML = items.map(function (it, i) {
      return '<div class="cod-it">' + (it.image ? '<img src="' + esc(img(it.image, 120)) + '" alt="">' : '<span></span>') +
        '<div><b>' + esc(it.title) + '</b><small>' + esc(it.variant || '') + '</small>' +
        '<div class="cod-q" data-i="' + i + '"><button type="button" data-d="-1" aria-label="One less">&minus;</button><i>' + it.quantity + '</i><button type="button" data-d="1" aria-label="One more">+</button></div></div>' +
        '<span>' + fmt(it.price * it.quantity) + '</span></div>';
    }).join('');
  }
  $('codItems').addEventListener('click', function (e) {
    var b = e.target.closest('[data-d]'); if (!b) return;
    var i = +b.parentNode.getAttribute('data-i'), it = items[i];
    var q = it.quantity + (+b.getAttribute('data-d'));
    if (q < 1) { if (items.length === 1) return; items.splice(i, 1); } else it.quantity = Math.min(q, 10);
    drawItems(); totals(); quote();
  });
  function local() {
    var sub = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0), ship = C.zones[state.zone].p;
    return { sub: sub, disc: 0, ship: ship, total: sub + ship };
  }
  function totals(q) {
    var t = q ? { sub: Math.round(q.subtotal * 100), disc: Math.round(q.discount * 100), ship: Math.round(q.shipping * 100), total: Math.round(q.total * 100) } : local();
    $('codSub').textContent = fmt(t.sub); $('codShip').textContent = fmt(t.ship); $('codTotal').textContent = fmt(t.total);
    $('codDiscRow').hidden = !t.disc; $('codDisc').textContent = '−' + fmt(t.disc);
    $('codGo').textContent = 'Confirm order · ' + fmt(t.total);
    state.total = t.total;
  }
  function payload(extra) {
    var o = { items: items.map(function (it) { return { variant_id: it.id, quantity: it.quantity }; }), zone: state.zone, code: state.code };
    for (var k in extra) o[k] = extra[k];
    return o;
  }
  function call(body) {
    return fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { error: 'server' }; }).then(function (j) { j._status = r.status; return j; }); });
  }
  // ask Shopify for the exact total (discounts included); the form still works if this is slow
  function quote() {
    var my = ++qt;
    call(payload({ action: 'quote' })).then(function (j) {
      if (my !== qt) return;
      if (j.ok) { state.quote = j; totals(j); }
      if (state.code) {
        if (j.ok && j.code_ok) $('codCodeMsg').textContent = 'Code ' + state.code + ' applied. You save ' + fmt(Math.round(j.discount * 100)) + '.';
        else if (j.ok) { $('codCodeMsg').textContent = j.code_msg || 'That code doesn’t work on this order.'; state.code = ''; }
      }
      if (j.error === 'sold_out' || j.error === 'preorder') $('codMsg').textContent = j.message;
    }).catch(function () {});
  }
  function setZone(z) { if (!C.zones[z]) return; state.zone = z; [].forEach.call(root.querySelectorAll('input[name=codZone]'), function (r) { r.checked = r.value === z; }); }
  [].forEach.call(root.querySelectorAll('input[name=codZone]'), function (r) { r.addEventListener('change', function () { state.zone = r.value; totals(); quote(); }); });
  $('codApply').addEventListener('click', function () {
    var c = ($('codCode').value || '').trim().toUpperCase(); if (!c) return;
    state.code = c; $('codCodeMsg').textContent = 'Checking…'; quote();
  });
  $('codCode').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('codApply').click(); } });

  // ---------- checks ----------
  function phoneOk(v) {
    var d = String(v || '').replace(/\D/g, ''); if (d.indexOf('880') === 0) d = d.slice(2); if (d.length === 10 && d[0] === '1') d = '0' + d;
    return /^01[3-9]\d{8}$/.test(d) ? d : '';
  }
  function bad(el, msg) { el.classList.add('err'); $('codMsg').textContent = msg; el.focus(); return false; }
  ['codName', 'codPhone', 'codEmail', 'codAddr'].forEach(function (id) { $(id).addEventListener('input', function () { this.classList.remove('err'); $('codMsg').textContent = ''; }); });

  // ---------- place the order ----------
  $('codGo').addEventListener('click', function () {
    if (busy) return;
    var n = $('codName').value.trim(), p = phoneOk($('codPhone').value), a = $('codAddr').value.trim(), em = ($('codEmail').value || '').trim();
    if (n.length < 2) return bad($('codName'), 'Please write your name.');
    if (!p) return bad($('codPhone'), 'Please give a valid mobile number, like 01712345678.');
    if (a.length < 8) return bad($('codAddr'), 'Please write your full address: house, road, area, thana, district.');
    if (em && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(em)) return bad($('codEmail'), 'That email doesn’t look right. Fix it or leave it empty.');
    try { localStorage.setItem('bbCodMe', JSON.stringify({ n: n, p: p, a: a, e: em, z: state.zone })); } catch (e) {}
    var attrs = { full_url: location.href.slice(0, 900) };
    try { var u = new URL(location.href), keep = JSON.parse(sessionStorage.getItem('bbUtm') || '{}'); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { attrs[k] = u.searchParams.get(k) || keep[k] || ''; }); } catch (e) {}
    busy = true; var go = $('codGo'), label = go.textContent; go.disabled = true; go.textContent = 'Placing your order…'; $('codMsg').textContent = '';
    call(payload({ action: 'order', name: n, phone: p, email: em, address: a, attrs: attrs })).then(function (j) {
      busy = false; go.disabled = false; go.textContent = label;
      if (!j.ok) { $('codMsg').textContent = j.message || ('Sorry, something went wrong. Please call ' + C.phone + '.'); if (j.error === 'phone') $('codPhone').classList.add('err'); return; }
      var total = Math.round(j.total * 100);
      track('Purchase', { value: j.total, currency: 'BDT', num_items: items.reduce(function (s, it) { return s + it.quantity; }, 0), content_type: 'product', content_ids: items.map(function (it) { return String(it.id); }) }, 'cod-' + j.order_id);
      $('codDoneName').textContent = ', ' + n.split(' ')[0];
      $('codDoneLine').textContent = 'Your order ' + j.order + ' is confirmed.';
      $('codDoneTotal').textContent = fmt(total);
      $('codDoneMail').hidden = !em; $('codDoneMail').textContent = em ? 'A receipt is on its way to ' + em + '.' : '';
      $('codForm').hidden = true; $('codDone').hidden = false; root.querySelector('.cod-box').scrollTop = 0;
      if (source === 'cart') fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(function () { if (window.bbSetCount) window.bbSetCount(0); });
      if (source === 'cart') [].forEach.call(root.querySelectorAll('#codDone [data-cod-close]'), function (b) { b.addEventListener('click', function () { location.href = '/'; }, { once: true }); });
    }).catch(function () {
      busy = false; go.disabled = false; go.textContent = label;
      $('codMsg').textContent = 'No connection. Please check your internet and try again.';
    });
  });

  // Meta pixel (when present)
  function track(ev, data, id) { try { if (window.fbq) window.fbq('track', ev, data || {}, id ? { eventID: id } : undefined); } catch (e) {} }

  // keep ad tags from the landing page for the order
  try { var u0 = new URL(location.href); if (u0.searchParams.get('utm_source') || u0.searchParams.get('fbclid')) { var keep = {}; ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { var v = u0.searchParams.get(k); if (v) keep[k] = v; }); sessionStorage.setItem('bbUtm', JSON.stringify(keep)); } } catch (e) {}

  // ---------- no size chosen yet: a small red note by the sizes ----------
  function needSize() {
    var row = document.getElementById('szrow'), sizes = document.getElementById('sizes'); if (!row) return;
    var n = document.getElementById('szNeed');
    if (n) n.remove();
    n = document.createElement('p'); n.id = 'szNeed'; n.className = 'sz-need'; n.setAttribute('role', 'alert');
    n.innerHTML = '<i aria-hidden="true">!</i><span>Select your size first</span>';
    var st = document.getElementById('stock'); (st && st.parentNode === row.parentNode ? st : row).insertAdjacentElement('afterend', n);
    row.classList.add('need');
    (sizes || row).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#szrow .sz')) { var n = document.getElementById('szNeed'); if (n) n.remove(); var r = document.getElementById('szrow'); if (r) r.classList.remove('need'); return; }
    var b = e.target.closest('#add, #barAdd, #payCod, #payNow'); if (!b) return;
    var row = document.getElementById('szrow');
    if (row && !row.querySelector('[aria-pressed="true"]')) { e.preventDefault(); e.stopImmediatePropagation(); needSize(); }
  }, true);

  // ---------- where it opens from ----------
  // product page: "Cash on delivery" box (only once a size is chosen; otherwise the page asks for one)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#payCod'); if (!b) return;
    var dataEl = document.getElementById('bbPdpData'); if (!dataEl) return;
    var row = document.getElementById('szrow');
    if (row && !row.querySelector('[aria-pressed="true"]')) return;
    var data = JSON.parse(dataEl.textContent), vid = +(($('bbEsId') || {}).value || 0);
    var v = data.variants.filter(function (x) { return x.id === vid; })[0]; if (!v || !v.available) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var h1 = document.querySelector('#buy h1'), main = document.getElementById('mainImg');
    open([{ id: v.id, quantity: 1, price: v.price, title: h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '', variant: /^\d+(\.5)?$/.test(v.title) ? 'EU ' + v.title : v.title.replace(/ \/ (\d)/, ' · EU $1'), image: v.img || (main && main.currentSrc) || '' }], 'product');
  }, true);
  // bag: "Order with cash on delivery"
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#bbkCod #checkout, [data-bb-cod]'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var list = (cart.items || []).filter(function (it) { return !(it.properties && it.properties['Pre-order']); }).map(function (it) {
        return { id: it.variant_id, quantity: it.quantity, price: it.final_price, title: it.product_title, variant: it.variant_title || '', image: it.image };
      });
      if (list.length) open(list, 'cart');
    });
  }, true);
  // came from a product page straight to the bag with cash on delivery chosen
  try { if (sessionStorage.getItem('bbAutoCod') === '1' && document.getElementById('bbkCod')) { sessionStorage.removeItem('bbAutoCod'); setTimeout(function () { var b = document.querySelector('#bbkCod #checkout'); if (b) b.click(); }, 300); } } catch (e) {}

  window.bbCodOpen = open;
})();
